import { z } from 'zod';
import { elementSchema, ideationBriefSchema, words } from '../brief/briefResult.js';
import { storyboardResultSchema, storyboardVersionSchema } from '../storyboard/storyboardResult.js';

export const bannerStoryboardVersionSchema = z.object({
  name: z.string(),
  strategy: z.string(),
  strategy_label: z.string().default(''),
  rationale: z.string(),
  creative_premise: z.string(),
  departure_from_references: z.string(),
  reference_ids: words,
  creative_direction: storyboardVersionSchema.shape.creative_direction,
  banner: z.object({
    headline: z.string(),
    subline: z.string().default(''),
    cta: z.string(),
    visual: z.string(),
    layout: z.string(),
    element_ids: words,
  }),
});
export const bannerStoryboardResultSchema = z.object({
  storyboard: z.object({
    name: z.string(),
    body: z.string(),
    aspect_ratio: z.string(),
    primary_kpi: z.string(),
    context: z.string(),
    production_instructions: z.string().default(''),
    source_brief: ideationBriefSchema.optional(),
    elements: z.record(z.string(), elementSchema),
    references: storyboardResultSchema.shape.storyboard.shape.references,
    warnings: words,
  }),
  versions: z.array(bannerStoryboardVersionSchema),
});
const bannerSchema = z.object({
  version_name: z.string(),
  strategy: z.string(),
  version: bannerStoryboardVersionSchema.optional(),
  size: z.string(),
  variation: z.number(),
  references_used: z.boolean().default(false),
  status: z.enum(['done', 'failed']),
  image_url: z.string().nullable().default(null),
  error: z.string().nullable().default(null),
  warnings: words,
  // Signed by tRPC; never derived from `image_url` here.
  playback_url: z.string().nullable().default(null),
});
export const bannerResultSchema = z.object({
  summary: z.string().nullable().optional(),
  banners: z.array(bannerSchema),
});

export type BannerStoryboardResult = z.infer<typeof bannerStoryboardResultSchema>;
export type BannerStoryboardVersion = z.infer<typeof bannerStoryboardVersionSchema>;
export type GeneratedBanner = z.infer<typeof bannerSchema>;
export type GeneratedBannerResult = z.infer<typeof bannerResultSchema>;
